import angular from 'angular';
import scenes from './scenes';
import insuranceFireAndGeneralModal from './insuranceFireAndGeneralModal';

export default angular
  .module('insuranceFireAndGeneral.scenes.insuranceFireAndGeneralModal', [
    scenes,
  ])
  .component('insuranceFireAndGeneralModal', insuranceFireAndGeneralModal).name;
